import axiosClient from '../../configs/axios.js';

class Deliveryakwnoledgmentreport {
  
    async DeliveryakwnoledgmentreportList(params) {
        try {
            const response = await axiosClient.get(
                `reports/DeliveryAcknowledgement`
            );
            return response.data;
        } catch (error) {
            console.error('Error fetching cylinder list:', error);
            throw error;
        }
    }
  

    

async editDeleteEmptyCollection(data) {
        try {
            const response = await axiosClient.put(`/emptycylinderColletion/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}
export default new Deliveryakwnoledgmentreport();